import { notification } from "antd";
import { ReactComponent as IconSuccess } from "../../../../assets/Icons/IconSuccess.svg";
import { ReactComponent as IconWarning } from "../../../../assets/Icons/IconWarning.svg";

interface SuccessModalConfig {
	message: string;
	description?: string | React.ReactNode;
	onClose?: () => void;
	duration?: number;
}

export const notificationSuccess = (config: SuccessModalConfig) => {
	return notification.success({
		message: config.message,
		description: config.description,
		style: {
			backgroundColor: "#DFF4E0",
			border: "1px solid #55C95A",
			width: 537,
		},
		// icon: <IconSuccess />,
		onClose: config.onClose,
		duration: config.duration,
	});
};

export const notificationWarning = (config: SuccessModalConfig) => {
	return notification.success({
		message: config.message,
		description: config.description,
		style: {
			backgroundColor: "#FFF3E1",
			width: 537,
		},
		icon: <IconWarning />,
	});
};

export const notificationInfo = (config: SuccessModalConfig) => {
	return notification.info({
		message: config.message,
		description: config.description,
		style: {
			backgroundColor: "#E6F4FF", // Biru muda
			border: "1px solid #91Caff",
			width: 537,
		},
		// icon: <IconWarning />,
	});
};

export const notificationError = (config: SuccessModalConfig) => {
	return notification.error({
		message: config.message,
		description: config.description,
		style: {
			backgroundColor: "#FFECEC", // Merah muda
			border: "1px solid #FF4D4F", // Merah terang
			width: 537,
		},
		// icon: <IconWarning />,
	});
};
